import { FC } from "react";
import colors from "@/constants/colors";
import Text from "../Text";
import { createUseStyles } from "react-jss";

interface Props {
  label: string;
  selected: boolean;
  first: boolean;
  last: boolean;
  onClick: () => void;
}

interface StyleProps {
  first: boolean;
  last: boolean;
  selected: boolean;
}

const useStyles = createUseStyles({
  button: {
    fontWeight: 500,
    padding: 10,
    flex: 1,
    whiteSpace: "break-spaces",
    cursor: "pointer",
    lineHeight: "18px",
    textAlign: "center",
    borderLeft: ({ first }: StyleProps) =>
      !first ? "1px solid rgba(224, 224, 224, 1)" : null,
    borderTopLeftRadius: ({ first }: StyleProps) => (first ? 12 : 0),
    borderBottomLeftRadius: ({ first }: StyleProps) => (first ? 12 : 0),
    borderTopRightRadius: ({ last }: StyleProps) => (last ? 12 : 0),
    borderBottomRightRadius: ({ last }: StyleProps) => (last ? 12 : 0),
    color: ({ selected }: StyleProps) =>
      selected ? colors.button.color.primary : null,
    backgroundColor: ({ selected }: StyleProps) =>
      selected ? colors.button.background.primary : null,
  },
});

export const ToggleButton: FC<Props> = ({
  label,
  selected,
  first,
  last,
  onClick,
}) => {
  const styles = useStyles({ selected, first, last });
  return (
    <Text onClick={onClick} className={styles.button}>
      {label}
    </Text>
  );
};
